/**
 * @import { Filters } from "../types/filters"
 */

const yearCount = 3;
const currentYear = new Date().getFullYear();

export const defaultYears = Array.from({ length: yearCount }, (_, index) => currentYear + index);

export const monthOptions = [
  {
    value: 0,
    label: 'Jan',
  },
  {
    value: 1,
    label: 'Feb',
  },
  {
    value: 2,
    label: 'Mar',
  },
  {
    value: 3,
    label: 'Apr',
  },
  {
    value: 4,
    label: 'May',
  },
  {
    value: 5,
    label: 'Jun',
  },
  {
    value: 6,
    label: 'Jul',
  },
  {
    value: 7,
    label: 'Aug',
  },
  {
    value: 8,
    label: 'Sep',
  },
  {
    value: 9,
    label: 'Oct',
  },
  {
    value: 10,
    label: 'Nov',
  },
  {
    value: 11,
    label: 'Dec',
  },
];

/**
 * Returns true when the provided filters contain a non-empty filter
 * @param {Filters} filters
 * @returns {boolean}
 */
export function hasFilters(filters) {
  return Object.values(filters).some((/** @type {Filters[keyof Filters]} */ value) => value.length > 0);
}
